import { kpf as commonKpf } from '@es/universal-common/kpf';
import { assign } from '../../core/utils';
function platformInterceptor(config) {
    try {
        var headers = config.headers || {};
        var headersWithPlatform = assign(headers, {
            kpn: config.kpn || '',
            kpf: config.kpf || commonKpf,
        });
        config.headers = headersWithPlatform;
    }
    catch (e) { }
    return config;
}
export default platformInterceptor;
//# sourceMappingURL=index.js.map